import React, { Component } from "react";
import Autosuggest from "react-autosuggest";
import Content from "../../content/Content";
import predictiveStyle from "../../assets/css/modules/shared/predictive-search.css";

export default class PredictiveSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      suggestions: []
    };
  }

  getSuggestions = (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    if (!this.props.healthTerms || inputLength === 0) {
      return [];
    }

    return this.props.healthTerms.filter(
      (healthTerm) =>
        healthTerm.toLowerCase().slice(0, inputLength) === inputValue
    );
  };

  onBlur = (event, { highlightedSuggestion }) => {
    this.props.onHealthTermSelected(highlightedSuggestion);
  };

  getSuggestionValue = (suggestion) => suggestion;

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value)
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  onSuggestionSelected = (event, { suggestion }) => {
    this.props.onHealthTermSelected(suggestion);
  };

  renderSuggestion = (suggestion) => <div>{suggestion} </div>;

  render() {
    const { suggestions } = this.state;

    const inputProps = {
      value: this.props.value,
      onChange: this.props.onChange,
      onBlur: this.onBlur,
      className: "form-control " + predictiveStyle.predictiveBox
    };

    return (
      <div>
        <div className="text-input fieldContainer">
          <div className="form-group">
            <label className="predictiveSearchLabel" htmlFor="AutoSuggest">
              <Content name={this.props.label} />
            </label>
            <div style={{ position: "relative" }}>
              <i
                className={
                  "icon-magnifier_glass " + predictiveStyle.predictiveSearchIcon
                }
              />
              <Autosuggest
                id="AutoSuggest"
                suggestions={suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                onSuggestionSelected={this.onSuggestionSelected}
                renderSuggestion={this.renderSuggestion}
                getSuggestionValue={this.getSuggestionValue}
                inputProps={inputProps}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
